import React from 'react'
import { ButtonSeeker, IconSeeker } from "@ui-seeker/core"
import { MAPPING_TYPE } from "Pages/User/CustomMapping/@constants"
import { setMappingFormData } from "Pages/User/CustomMapping/@signals"

export default function CreateCustomMappingButton({ path }) {

	return <ButtonSeeker startIcon={<IconSeeker icon="plus"/>} onClick={() => setMappingFormData(path, 'create')}>
		Create custom {path === MAPPING_TYPE.ACRISS ? "ACRISS" : "Category"}
	</ButtonSeeker>
}